import { FC } from 'react';
import { Typography } from '@duxton-web/ui';
import { ArrowLeftUniversal } from '@duxton-web/icons';
import { useNavigate, useMatch, useLocation } from 'react-router-dom';
import jsBridge from '@utils/jsBridge';
import crmTracker from '@utils/tracking/crmTracker';
import { stateName, EVENT, pathStateNameMap } from '@utils/tracking/enums';
import { clearUserData } from '@utils/loginHelper';
import { useIsInWebView } from '@hooks/useDeviceType';

const { Title } = Typography;

type HeaderProps = {
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  title?: string;
  shouldDisplayOnDesktop?: boolean;
};

export const iconClassName = 'p-2 text-2xl';

const Header: FC<HeaderProps> = ({ leftIcon, rightIcon, title, shouldDisplayOnDesktop = false }) => {
  const navigate = useNavigate();
  const isHome = useMatch('/');
  const location = useLocation();
  const isInWebView = useIsInWebView();
  const path = location.pathname;

  const onBack = () => {
    if (isHome) {
      crmTracker.sendEvent(stateName.CRM_HOMEPAGE, EVENT.CLICK_BACK);
      if (jsBridge.canUseBridge()) {
        clearUserData();
      }
      jsBridge.openSchema('mexapp://action?type=dismiss');
    } else {
      crmTracker.sendEvent(pathStateNameMap[path], EVENT.CLICK_BACK);
      navigate(-1);
    }
  };

  return (
    <div
      className={`sticky top-0 z-100 flex w-full justify-between bg-white px-4 py-4 ${
        shouldDisplayOnDesktop || isInWebView ? '' : 'md:hidden'
      }`}
    >
      <div className="flex h-[40px] items-center gap-2">
        {leftIcon || <ArrowLeftUniversal className={iconClassName} onClick={onBack} />}
        <Title level={5} style={{ marginBottom: 0 }}>
          {title}
        </Title>
      </div>
      {rightIcon}
    </div>
  );
};

export default Header;
